export default "__VITE_ASSET__b95d254b__"